import { Title } from '@angular/platform-browser';
import { Component, Input, AfterViewInit, OnInit, OnDestroy, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';

import { PageService } from '@services/page.service';

@Component({
  selector: 'smrts-page',
  templateUrl: './page.component.html',
  styleUrls: [
    './page.component.scss'
  ],
  standalone: false
})

export class PageComponent implements OnInit, AfterViewInit, OnDestroy {

  constructor(
    private pageService: PageService,
    private titleService: Title,
    private changeDetectorRef: ChangeDetectorRef
  ) { }

  @ViewChild('primaryTitleEl') primaryTitleEl?: ElementRef<HTMLElement>;

  @Input() hasHeader: boolean = true;
  @Input() hasFootnote: boolean = false;
  @Input() primaryTitle: string = '';
  @Input() tabTitle: string = '';

  contentMarginTop: string = '0';
  contentMarginBottom: string = '0';
  isTitleOverflowing: boolean = false;

  ngOnInit(): void {
    if (this.tabTitle)
      this.titleService.setTitle(this.tabTitle);
    else if (this.primaryTitle)
      this.titleService.setTitle(this.primaryTitle);
    else
      this.titleService.setTitle('GMA');
  }

  ngAfterViewInit(): void {
    this.setContentMargin();
    this.checkTitleOverflow();
  }

  ngOnDestroy(): void {
    this.contentMarginTop = '0px';
    this.contentMarginBottom = '0px';
    this.changeDetectorRef.detectChanges();
  }

  openSidenav(): void {
    this.pageService.openSidenav.emit();
  }

  onResize(): void {
    this.setContentMargin();
    this.checkTitleOverflow();
  }

  checkTitleOverflow(): void {
    const el = this.primaryTitleEl?.nativeElement;
    this.isTitleOverflowing = !!el && el.scrollWidth > el.clientWidth;
  }

  setContentMargin(): void {
    if (this.hasHeader) {
      this.contentMarginTop = '90px';
    }

    if (this.hasFootnote) {
      const footnoteHeight = this.getHeight('page-footnote');
      this.contentMarginBottom = footnoteHeight + 'px';
    }

    this.changeDetectorRef.detectChanges();
  }

  getHeight(elementID: string): number {
    const div = document.getElementById(elementID);
    if (!div)
      return 0;

    const style = window.getComputedStyle(div);
    const temp = style.getPropertyValue('height');
    const height = parseInt(temp, 10);

    return height;
  }
}
